import "slick-carousel/slick/slick";
import Parallax from "parallax-js";
import Accordion from "@/modules/containers/accordion";
import { starRating } from "@/scripts/helpers/jquery.star-rating-svg.js";
import Cookies from "js-cookie";
import video from "@/modules/accessability-exp-10743/video/video";
import { initWowLibrary } from "@/scripts/helpers/wowAnimation";
import { addedLazyLoadImages } from "@/scripts/helpers/imgLazyload";
import Tabs from "@/modules/containers/tabs";
import showMoreFeatures from "@/modules/features-links/features-links";
import modalShow from "@/modules/containers/modal/modal";
import { introTogglerModal } from "@/modules/containers/modal-forms-version/index";
import favoriteSlider from "@/pages/forms/forms-favorite/index";
import modalFormsVersions from "@/pages/forms/forms-versions/index";
import { onCEGetFormClick } from "@/scripts/helpers/googleAnalyticsEvents"

$(".js-show-details").on("click", function() {
  changeDetailFormTitle(this);
});

const formLoader = () => {
  const formButton = $(".js-editor-link");
  let ctaClickFlag = true;
  let loaderState = false;

  if (formButton.length) {
    formButton.on("click", function(event) {
      event.preventDefault();

      showLoader();
      resetScrollBar();

      if (ctaClickFlag) {
        ctaClickFlag = false;

        const formId = $(".page-section--greeting, .page-section--intro").attr(
          "data-formId"
        );
        const token = $("meta[name='csrf-token']").attr("content");

        $.ajax({
          url: "/forms/get-editor-data",
          type: "POST",
          data: {
            id: formId
          },
          dataType: "json",
          headers: { "X-CSRF-TOKEN": token },
          success: function(data) {
            let editorUrl = data.editorUrl;
            showLoader();
            const loader = document.querySelector(".js-form-loader");
            if (loader.classList.contains("is-show")) {
              loaderState = true;
            }
            resetScrollBar();
            setTimeout(() => {
              window.location.href = editorUrl;
            }, 700);
          },
          error: function(data) {
            hideLoader()
          },
        });
      }
    });
  }

  $(document).on("keydown keypress", function(e) {
    let charCode = e.charCode || e.keyCode || e.which;
    if (charCode === 27 && loaderState) {
      setTimeout(function() {
        window.location.reload(true);
      }, 200);
      return false;
    }

    if (charCode === 13 && loaderState) {
      return false;
    }
  });

  const showLoader = el => {
    const $loader = "#form-loader";
    let element = el || $loader;

    if ($(element).length) {
      $(element).addClass("is-show");
    }
    return true;
  };

  const detectScrollBar = () => {
    // Create the measurement node
    let scrollDiv = document.createElement("div");
    scrollDiv.className = "scrollbar-measure";
    document.body.appendChild(scrollDiv);

    // Get the scrollbar width
    let scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;

    // Delete the DIV
    document.body.removeChild(scrollDiv);

    return scrollbarWidth;
  };

  const resetScrollBar = () => {
    const $body = $("body");
    let scrollWidth = detectScrollBar();

    $body.addClass("modal-open");
    if (scrollWidth > 0) {
      $body.css({ "padding-right": scrollWidth });
    }

    return false;
  };
};

const changeDetailFormTitle = selector => {
  const title = $(selector).find(".greeting-collapsed__title");
  $(selector).toggleClass("is-open");
  if ($(window).width() < 767) {
    $(title).removeClass("js-hide-link-line");
    setTimeout(function() {
      $(title).addClass("js-hide-link-line");
    }, 150);
  } else {
    $(title).removeClass("js-hide-link-line");
  }
  $(title).text() === "Show details"
    ? $(title).html("Hide details")
    : $(title).html("Show details");
};

const initParallaxDecorations = scene => {
  const parallaxInstance = new Parallax(scene[0], {
    pointerEvents: false,
    invertX: false,
    invertY: false,
    relativeInput: false
  });

  parallaxInstance.friction(0.2, 0.2);
};

const ratingStar = () => {
  $(".js-form-rating").starRating({
    totalStars: 5,
    starShape: "rounded",
    starSize: 17,
    emptyColor: "#e2e2e2",
    hoverColor: "#ffd74c",
    activeColor: "#ffd74c",
    ratedColor: "#ffd74c",
    useGradient: false,
    useFullStars: true,
    disableAfterRate: false,
    forceRoundUp: true,
    callback: function(currentRating) {
      const formId = $("#form-id").val();
      if (!Cookies.get(`form_rating_${formId}`)) {
        $.ajax({
          url: "/forms/ajaxRatingForm",
          type: "POST",
          data: {
            star_input: currentRating,
            form_id: formId
          },
          dataType: "json",
          headers: {
            "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content")
          }
        });
        Cookies.set(`form_rating_${formId}`, currentRating);
      }
    }
  });
};

export const initParallaxMobile = () => {
  const tabletBreakpoint = 767;
  if ($(window).width() > tabletBreakpoint) {
    const scene = $(".js-decorations-key-group");
    $(scene).each(function() {
      initParallaxDecorations($(this));
    });
  }
};

const mainCoverLazy = selector => {
  let element = $(selector);
  let lazyImgSrc = element.attr("data-src");

  element.attr("src", lazyImgSrc);
};
const $formPreview = $(".js-form-preview");
if ($formPreview.length) {
  mainCoverLazy($formPreview);
  setTimeout(function() {
    $(".form-preview").addClass("is-show");
  }, 100);
}

const introToggler = () => {
  $(".js-intro-show-more").click(function(e) {
    e.preventDefault();

    $(".intro-content-togler").toggleClass("is-active");
    $(".intro-content-togler__text").slideToggle();
    $(this).text(
      $(this).text() == "Show details" ? "Hide details" : "Show details"
    );
    $(this).toggleClass("is-active");
  });
};

const getFormCE = () => {
  const getFormBtns = document.querySelectorAll(".button.js-editor-link");
  getFormBtns.forEach(e => e.addEventListener("click", onCEGetFormClick))
};

$(document).ready(function() {
  initWowLibrary();
  Accordion();
  introTogglerModal();
  formLoader();
  Tabs();
  video();
  modalShow();
  showMoreFeatures();
  addedLazyLoadImages();
  ratingStar();
  initParallaxMobile();
  mainCoverLazy();
  introToggler();
  favoriteSlider();
  modalFormsVersions();
  getFormCE();
});

const hideLoader = el => {
  const $body = $("body");
  const $loader = "#form-loader";
  let element = el || $loader;

  if ($(element).hasClass("is-show")) {
    $(element).removeClass("is-show");
  }

  if ($body.hasClass("modal-open")) {
    $body.removeClass("modal-open");
    $body.css({ "padding-right": 0 });
  }
  return true;
};

// window.addEventListener(
//   "beforeunload",
//   function() {
//     hideLoader();
//   },
//   false
// );

window.addEventListener(
  "pageshow",
  function(evt) {
    if (evt.persisted) {
      setTimeout(function() {
        window.location.reload();
      }, 10);
    }
  },
  false
);
